module.exports = __webpack_public_path__ + "img/BINDI 5 B.63a639c.svg";